<template>
  <div>
    <v-chip :color="statusType(status,true)">
      <span class="text-white"> {{ statusType(status,false) }}</span>
    </v-chip>
  </div>
</template>
<script>

import {statusDatas} from '@/utils/enums/statusDatas';
export default {
   props: {
    status: {
      type: Number,
      required: true,
    },
  
  },
  methods: {
    statusType: (status,textoOuCor) => {
      if (status === statusDatas.NORMAL.id) {
        return textoOuCor ?  "success" :statusDatas.NORMAL.label;
      }

      if (status === statusDatas.PREVISAO.id) {
        return textoOuCor ?  "success" :statusDatas.PREVISAO.label;
      }
      if (status === statusDatas.SOLICITACAO.id) {
        return textoOuCor ?  "primary" :statusDatas.SOLICITACAO.label;
      }

      if (status === statusDatas.VENCIDO.id){
        return textoOuCor ?  "red" :statusDatas.VENCIDO.label;
      }
      if (status === statusDatas.PROXIMO_DO_VENCIMENTO.id) {
        return textoOuCor ?  "warning" :statusDatas.PROXIMO_DO_VENCIMENTO.label;
      }
      if (status === statusDatas.DEFINITIVO.id) {
        return textoOuCor ?  "primary" :statusDatas.DEFINITIVO.label;
      }
      return textoOuCor ?  "default" :statusDatas.INDEFINIDO.label;
    },
  },
};
</script>